<template>
  <div>
    <h3>{{ $t('message.balance')}}: <span>{{ formattedBalance }}</span></h3>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import utils from '../../../utils';

export default {
  name: 'PanelBalance',
  computed: {
    ...mapGetters(['balance', 'currency']),
    formattedBalance() {
      return utils.convertSystemToCurrency(this.balance, this.currency);
    }
  },
}
</script>


<style scoped>
div {
  padding: 2px 20px 3px 20px;
  background: #e0edf8;
  border-radius: 5px;
  font-size: 100%;
  font-style: normal;
  outline: 0;
  display: block;
  text-align: left;
  font-family: Verdana, sans-serif;
  color: #000;
}

h3 {
  color: #666;
  font-size: 16px;
  font-family: Verdana, sans-serif;
  font-weight: normal;
  font-style: normal;
  display: block;
  margin-bottom: 8px;
  padding-top: 8px;
}

span {
  color: #cc66cc;
  float: right;
  font-size: 100%;
  font-style: normal;
  vertical-align: baseline;
  font-family: Verdana, sans-serif;
  font-weight: normal;
  text-align: left;
}

</style>
